import React, { useRef, useState } from "react";

function ComponentPricePackeageAE({ Product, Amounts, setAmounts }) {
  const inputRefs = useRef([]);
  const [ActiveProd, SetActiveProd] = useState();

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const DoChangeCount = async (ProductId, Amount) => {
    let copy = [...Amounts];
    let excist = copy.find((e) => e.Id == ProductId);
    if (excist) {
      copy.find((e) => e.Id == ProductId).Count = Amount;
    } else {
      let data = {
        Id: ProductId,
        Count: Amount,
        Price: 0,
      };
      copy.push(data);
    }
    setAmounts(copy);
  };
  const DoChangePrice = async (ProductId, Amount) => {
    let copy = [...Amounts];
    let excist = copy.find((e) => e.Id == ProductId);
    if (excist) {
      copy.find((e) => e.Id == ProductId).Price = Amount.replace(/,/g, "");
    } else {
      let data = {
        Id: ProductId,
        Price: Amount.replace(/,/g, ""),
        Count: 0,
      };
      copy.push(data);
    }
    setAmounts(copy);
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center w-100 tableC">
        <table className="table">
          <thead className="sticky-header">
            <tr className="trTable">
              <th>نام محصول</th>
              <th>تعداد</th>
              <th>قیمت</th>
              <th>اخرین قیمت</th>
            </tr>
          </thead>
          {Product && (
            <tbody className="identitystyle">
              {Product.map((itemPro, keyPro) => (
                <tr
                  className={`${itemPro.id == ActiveProd && "bg-warning"}`}
                  key={itemPro.id}
                >
                  <td>
                    {itemPro.productTypeName != " " &&
                      itemPro.productTypeName + " "}
                    {itemPro.productSeriesName != " " &&
                      itemPro.productSeriesName}
                    {itemPro.symbol}
                    {itemPro.productSeriesEndName != " "
                      ? itemPro.productSeriesEndName + " "
                      : " "}
                    {itemPro.productRamName != " " &&
                      itemPro.productRamName + "/"}
                    {itemPro.productRomName != " " &&
                      itemPro.productRomName + " "}
                    {itemPro.productNetworkName != " " &&
                      itemPro.productNetworkName + " "}
                    {itemPro.productCountryName != " " &&
                      itemPro.productCountryName + " "}
                    {itemPro.isInsurance && "بیمه"}
                  </td>
                  <td>
                    <input
                      ref={(el) => (inputRefs.current[keyPro] = el)}
                      onFocus={() => SetActiveProd(itemPro.id)}
                      value={Amounts?.find((e) => e.Id === itemPro.id)?.Count}
                      onChange={(e) => {
                        DoChangeCount(itemPro.id, e.target.value);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, keyPro)}
                      className="m-2"
                      type="text"
                    />
                  </td>
                  <td
                    className={
                      itemPro.lastPrice * 1.1 <
                        Amounts.find((e) => e.Id === itemPro.id)?.Price ||
                      itemPro.lastPrice * 0.9 >
                        Amounts.find((e) => e.Id === itemPro.id)?.Price
                        ? "ghermez"
                        : ""
                    }
                  >
                    <input
                      onFocus={() => SetActiveProd(itemPro.id)}
                      value={Amounts.find((e) => e.Id === itemPro.id)
                        ?.Price.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      onChange={(e) => {
                        DoChangePrice(itemPro.id, e.target.value);
                      }}
                      onKeyDown={(e) => handleKeyDown(e, keyPro)}
                      className="m-2"
                      type="text"
                    />
                  </td>
                  <td
                    className={
                      itemPro.lastPrice * 1.1 <
                        Amounts.find((e) => e.Id === itemPro.id)?.Price ||
                      itemPro.lastPrice * 0.9 >
                        Amounts.find((e) => e.Id === itemPro.id)?.Price
                        ? "ghermez"
                        : ""
                    }
                  >
                    {itemPro?.lastPrice
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
}

export default ComponentPricePackeageAE;
